import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "page",
  "use": "page-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"page\"><path fill-rule=\"evenodd\" d=\"M4.01 4 4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6c-1.1 0-1.99.9-1.99 2ZM13 3.5 18.5 9H13V3.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol